/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { BottomNavigation, BottomNavigationAction } from "@material-ui/core"
import { useLocation, useHistory, useRouteMatch } from "react-router-dom"
import { ChangeEvent, useContext } from "react"
import AuthContext from "../../context/AuthContext"
import ListIcon from "@material-ui/icons/ListRounded"
import ShoppingCartRoundedIcon from "@material-ui/icons/ShoppingCartRounded"
import PeopleAltRoundedIcon from "@material-ui/icons/PeopleAltRounded"
import LocalOfferRoundedIcon from "@material-ui/icons/LocalOfferRounded"
import AssignmentRoundedIcon from "@material-ui/icons/AssignmentRounded"

function OrganizationMobileNavBar() {
    const location = useLocation()
    const currentValue = location.pathname.split("/")[2]
    const history = useHistory()
    const { url } = useRouteMatch()
    const auth = useContext(AuthContext)

    const handleNavChange = (_: ChangeEvent<{}>, newValue: string) => {
        history.push(`${url}/${newValue}`)
    }

    return (
        <BottomNavigation
            onChange={handleNavChange}
            value={currentValue}
            css={styles.root}
        >
            <BottomNavigationAction value="products" icon={<ListIcon />} />
            {auth?.role === "admin" && (
                <BottomNavigationAction
                    value="users"
                    icon={<PeopleAltRoundedIcon />}
                />
            )}
            {auth?.role === "admin" && (
                <BottomNavigationAction
                    value="discounts"
                    icon={<LocalOfferRoundedIcon />}
                />
            )}
            <BottomNavigationAction
                value="orders"
                icon={<AssignmentRoundedIcon />}
            />
            <BottomNavigationAction
                value="cart"
                icon={<ShoppingCartRoundedIcon />}
            />
        </BottomNavigation>
    )
}

export default OrganizationMobileNavBar

const styles = {
    root: css`
        position: fixed;
        width: 100%;
        bottom: 0;
        text-align: center;
        left: 0;
        z-index: 100;
    `,
}
